import { IReward } from './IReward';
import { Reward } from './Reward';
import EatsTransactionTypes from './EatsTransactionTypes';

export class EatsReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.EatsReward';

	public static readonly NAME: string = 'Eats';

	transactionType: string = EatsTransactionTypes.ALL.value;

	cashBackRate: number = 0;

	purchaseLimit: number = 0;

	constructor(reward?: IReward) {
	  super(EatsReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.cashBackRate = (reward as any).cashBackRate;
	    this.purchaseLimit = (reward as any).purchaseLimit;
	    this.transactionType = (reward as any).transactionType;
	  }
	}

	getDescription(): string {
	  let description = `${this.cashBackRate}% cash back on up to $${
	    this.purchaseLimit} of `;

	  switch (this.transactionType) {
	    case EatsTransactionTypes.GROCERY.value:
	      description += 'grocery';
	      break;

	    case EatsTransactionTypes.MEAL_DELIVERY.value:
	      description += 'meal delivery';
	      break;

	    default:
	      description += 'food';
	  }

	  description += ' purchases';
	  return description;
	}

	clone(): IReward {
	  const clone = new EatsReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default EatsReward;
